import { IRouteProps } from '@partnerconnect-monorepo/types/Routes';
import { lazy } from 'react';

const Home = lazy(
  () => import('@partnerconnect-monorepo/home-lib/pages/Home/Home.connect')
);

export const routes: Array<IRouteProps> = [
  {
    path: '/',
    component: Home,
    isDefault: true
  }
];
